import config from 'configDir/index';
import { get } from './http';

const baseUrl = '/operator';
const { resourceUrl } = config;

//  模糊查询运营商
const searchOperatorService = get(`${baseUrl}/searchOperator`, resourceUrl);

export {
  // eslint-disable-next-line import/prefer-default-export
  searchOperatorService,
};
